<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <dx-toolbar class="theme-dependent">
            <dxi-item location="before">
                <div class="header-text">Facility Capacity</div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="normal"
                    (onClick)="cancel()"
                >
                </dx-button>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    text="Save"
                    stylingMode="contained"
                    type="default"
                    (onClick)="save()"
                >
                </dx-button>
            </dxi-item>
        </dx-toolbar>
    </div>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'facility-capacity' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll">
        @if (!isLoading) {
            <div class="form-container">
                <div class="card border-0 shadow-sm pt-0">
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <div class="mb-4">
                                    <label class="form-label">Ambient Capacity</label>
                                    <dx-number-box
                                        [(value)]="capacity.ambientCapacity"
                                        [min]="0"
                                        stylingMode="filled"
                                    ></dx-number-box>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-4">
                                    <label class="form-label">Cooler Capacity</label>
                                    <dx-number-box
                                        [(value)]="capacity.coolerCapacity"
                                        [min]="0"
                                        stylingMode="filled"
                                    ></dx-number-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </dx-scroll-view>
</div>

